import { structuralBreakdownLogic } from './structural_breakdown.logic';
import { GAME_MODE_CATALOG } from '../../core/types/gameMode.types';
import type { ActivityPlugin } from '../../core/types/activity.types';
import { StructuralBreakdownView } from '../humanities/StructuralBreakdownBlock';

export const structuralBreakdownPlugin: ActivityPlugin<'structural_breakdown'> = {
  ...structuralBreakdownLogic,
  displayName: GAME_MODE_CATALOG.structural_breakdown.displayName,
  icon: GAME_MODE_CATALOG.structural_breakdown.icon,
  HostView: StructuralBreakdownView,
  StudentView: StructuralBreakdownView,
  ProjectorView: StructuralBreakdownView,
};

export { demoStructuralBreakdownPayload } from './structural_breakdown.logic';
